import React, { useRef } from 'react';
import { connect } from 'dva';
import { CSSTransitionGroup } from 'react-transition-group';
import PropTypes from 'prop-types';
import actions from './actions';
import Info from '../../../assets/svg/Feather/Info';
import Loader from '../../Loader';
import noop from 'lodash-es/noop';
import styles from './MapToast.module.scss';
import X from '../../../assets/svg/Feather/X';

function MapToast(props) {
  // Track the last known variant so the leave animation uses the correct
  // placement/transition even after props.toast becomes null mid-animation.
  const lastVariantRef = useRef(null);
  if (props.toast != null) {
    lastVariantRef.current = props.toast.placement ?? null;
  }

  const isTopVariant = lastVariantRef.current === 'top';

  const getIcon = () => {
    if (props.toast?.loader) {
      return <Loader className={styles.toastLoader} active={true} small />;
    }

    if (props.toast?.icon) {
      const IconCmp = props.toast.icon;
      return (
        <IconCmp
          color={props.toast.iconColor ? props.toast.iconColor : '#F37735'}
          width={14}
        />
      );
    } else {
      return (
        <Info
          color={props.toast.iconColor ? props.toast.iconColor : '#F37735'}
          width={14}
        />
      );
    }
  };

  const onClick = (e) => {
    if (props.toast?.onClick != null) {
      props.toast.onClick(e);
    } else {
      noop();
    }
  };

  const placementClass = isTopVariant
    ? styles.topPlacementContainer
    : styles.toastPlacementContainer;

  const containerClass = [
    isTopVariant ? styles.topToastContainer : styles.toastContainer,
    props.toast?.onClick != null ? styles.clickableToast : '',
  ].join(' ');

  const textClass = [
    styles.toastText,
    isTopVariant ? styles.topToastText : '',
  ].join(' ');

  const dismissClass = [
    styles.dismiss,
    isTopVariant ? styles.topDismiss : '',
  ].join(' ');

  return (
    <div className={placementClass}>
      <CSSTransitionGroup
        transitionName={isTopVariant ? 'toast-top' : 'toast'}
        transitionEnterTimeout={220}
        transitionLeaveTimeout={200}
      >
        {props.toast != null && (
          <div className={containerClass}>
            {getIcon()}
            <p className={textClass} onClick={onClick}>
              {props.toast.text}
            </p>
            {props.toast.dismissable ? (
              <button className={dismissClass} onClick={props.dismiss}>
                <X width={14} />
              </button>
            ) : null}
          </div>
        )}
      </CSSTransitionGroup>
    </div>
  );
}

MapToast.propTypes = {
  toast: PropTypes.object,
  // actions
  dismiss: PropTypes.func,
};

export default connect((model) => {
  return {
    toast: model.toast.message,
  };
}, actions)(MapToast);
